import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Navbar.module.css';

function Navbar() {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleDropdownClose = () => {
    if (!isMobile) {
      setActiveDropdown(null);
    }
  };

  const handleDropdownEnter = (dropdown) => {
    if (!isMobile) {
      setActiveDropdown(dropdown);
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setActiveDropdown(null);
  };

  const toggleMobileDropdown = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.navbarContainer}>
        <Link to="/" className={styles.navbarLogo} onClick={closeMobileMenu}>
          <img src="/img/sainet_logo.svg" alt="Sapienta VC" className={styles.logoImg} />
        </Link>

        <button
          className={`${styles.burgerButton} ${mobileMenuOpen ? styles.burgerOpen : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`${styles.navMenu} ${mobileMenuOpen ? styles.navMenuOpen : ''}`}>
          <li className={styles.navItem}>
            <Link to="/" className={styles.navLink} onClick={closeMobileMenu}>Home</Link>
          </li>

          <li className={`${styles.navItem} ${styles.dropdown}`}
              onMouseEnter={() => handleDropdownEnter('investment')}
              onMouseLeave={handleDropdownClose}>
            <span
              className={`${styles.navLink} ${styles.dropdownToggle}`}
              onClick={() => toggleMobileDropdown('investment')}
            >
              Investment
            </span>
            <ul className={`${styles.dropdownMenu} ${activeDropdown === 'investment' ? styles.show : ''}`}>
              <li><Link to="/portfolio" className={styles.dropdownLink} onClick={closeMobileMenu}>Portfolio</Link></li>
              <li><Link to="/investment-criteria" className={styles.dropdownLink} onClick={closeMobileMenu}>Investment Criteria</Link></li>
              <li><Link to="/investment-philosophy" className={styles.dropdownLink} onClick={closeMobileMenu}>Investment Philosophy</Link></li>
            </ul>
          </li>

          <li className={styles.navItem}>
            <Link to="/company-information" className={styles.navLink} onClick={closeMobileMenu}>Company</Link>
          </li>

          {/* 8Decimals Digital Assets menu - commented out
          <li className={`${styles.navItem} ${styles.dropdown}`}
              onMouseEnter={() => handleDropdownEnter('digital')}
              onMouseLeave={handleDropdownClose}>
            <span
              className={`${styles.navLink} ${styles.dropdownToggle}`}
              onClick={() => toggleMobileDropdown('digital')}
            >
              Digital Assets
            </span>
            <ul className={`${styles.dropdownMenu} ${activeDropdown === 'digital' ? styles.show : ''}`}>
              <li><a href="https://8decimals.com/" target="_blank" rel="noopener noreferrer" className={styles.dropdownLink} onClick={closeMobileMenu}>8Decimals Fund</a></li>
            </ul>
          </li>
          */}

          <li className={styles.navItem}>
            <Link to="/careers" className={styles.navLink} onClick={closeMobileMenu}>Careers</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar; 